import type { HandledWorkspace } from 'state/forms/models';
import { costAndChargeReceived } from 'state/quotes/regulations/regulation.actions';
import { streamingPriceReceived } from 'state/quotes/streaming/streaming.actions';
import { Thunk } from 'state/state.common';
import { QuotePriceEvent, RemainingValues } from 'utils/streaming/quotePriceEvent';

export function streamingPriceReceivedThunk(
  tabId: string,
  price: QuotePriceEvent<RemainingValues>,
  workspace: HandledWorkspace,
): Thunk<void> {
  return dispatch => {
    dispatch(streamingPriceReceived(tabId, price));
    dispatch(
      costAndChargeReceived(workspace, tabId, price.quoteId, {
        costsAndCharges: price.costsAndCharge ?? [],
        theoreticalValue: [],
      }),
    );
  };
}
